// src/components/Service/Service.jsx
import React from "react";
import "./Service.css";

const services = [
  {
    img: "./images/Web Dev.png",
    title: "Web Development",
    description:
      "I create dynamic and responsive websites tailored to your needs. Experienced in developing personal, educational, e-commerce, business, tourism, and hotel websites with clean code and modern design principles.",
  },
  {
    img: "./images/Designer Logo .png",
    title: "Designing",
    description:
      "Skilled in both mechanical and digital design, using CATIA V5, AutoCAD, Photoshop, and Blender. I focus on precision, functionality, and creativity to deliver professional and visually appealing designs.",
  },
  {
    img: "./images/3d Printing logo.png",
    title: "3D Printing",
    description:
      "Proficient with Prusa 3D printers and customized filaments. I produce high-quality 3D printed products according to your design specifications, delivering across India with care and precision.",
  },
];

const Service = () => {
  return (
    <section className="services section-padding" id="service">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-header text-center">
              <h2>MY SERVICES</h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {services.map((service, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
              <div className={`card gradient${index + 1} text-center h-100`}>
                <div className="card-body">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="service-img"
                  />
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
